import React, { useEffect, useState } from 'react';
import API from '../services/api';
import { useAuth } from '../context/AuthContext';
import { useGeneralMsgUpdate } from '../context/GenralMsgContext';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import NoteCard from '../components/NoteCard';
import '../css/AllNotesDashboard.css';

const AllNotesDashboard = () => {
  const { user } = useAuth();
  const setGeneralMsg = useGeneralMsgUpdate();
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchNotes = async () => {
    setLoading(true);
    try {
      const res = await API.get('/notes');
      setNotes(res.data);
    } catch (err) {
      setGeneralMsg('Failed to fetch notes', 'error');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchNotes();
    // eslint-disable-next-line
  }, []);

  const handleExport = () => {
    if (!notes.length) return;
    const exportData = notes.map(note => ({
      Title: note.title || '',
      Content: note.noteContent || '',
      Profile: note.profileUsername || '',
      UpdatedAt: note.updatedAt ? new Date(note.updatedAt).toLocaleString() : '',
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Notes');
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'MyNotes.xlsx');
  };

  const handleNoteUpdate = (updatedNote) => {
    setNotes(prev =>
      prev.map(note => note._id === updatedNote._id ? updatedNote : note)
    );
  };

  const handleNoteDelete = (deletedId) => {
    setNotes(prev => prev.filter(note => note._id !== deletedId));
  };

  return (
    <div className="all-notes-dashboard">
      <div className="dashboard-header">
        <h1>My Notes</h1>
        <button className="btn" onClick={handleExport} disabled={!notes.length}>
          Export to Excel
        </button>
      </div>
      {loading ? (
        <div className="dashboard-loading">Loading notes...</div>
      ) : (
        <div className="notes-grid">
          {notes.length === 0 ? (
            <div className="no-notes-msg">No notes found.</div>
          ) : (
            notes.map(note => (
              <NoteCard
                key={note._id}
                note={note}
                onUpdate={handleNoteUpdate}
                onDelete={handleNoteDelete}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default AllNotesDashboard;
